export async function instantiate(module, imports = {}) {
  const adaptedImports = {
    env: Object.assign(Object.create(globalThis), imports.env || {}, {
      abort(message, fileName, lineNumber, columnNumber) {
        // ~lib/builtins/abort(~lib/string/String | null?, ~lib/string/String | null?, u32?, u32?) => void
        message = __liftString(message >>> 0);
        fileName = __liftString(fileName >>> 0);
        lineNumber = lineNumber >>> 0;
        columnNumber = columnNumber >>> 0;
        (() => {
          // @external.js
          throw Error(`${message} in ${fileName}:${lineNumber}:${columnNumber}`);
        })();
      },
      "host.entity_resurrect"(entity, life, max_life) {
        // assembly/external/entity_resurrect(u32, u32, u32) => void
        entity = entity >>> 0;
        life = life >>> 0;
        max_life = max_life >>> 0;
        host.entity_resurrect(entity, life, max_life);
      },
      "host.update_entity_params"(entity, is_dead, life, max_life, shield, max_shield, select_radius, atack_distance, attack_time) {
        // assembly/external/update_entity_params(u32, bool, u32, u32, f32, f32, f32, f32, f32) => void
        entity = entity >>> 0;
        is_dead = is_dead != 0;
        life = life >>> 0;
        max_life = max_life >>> 0;
        host.update_entity_params(entity, is_dead, life, max_life, shield, max_shield, select_radius, atack_distance, attack_time);
      },
      "host.define_level"(level_width, level_height, tile_size) {
        // assembly/external/define_level(u32, u32, f32) => void
        level_width = level_width >>> 0;
        level_height = level_height >>> 0;
        host.define_level(level_width, level_height, tile_size);
      },
      "host.define_total_tiles"(total_tiles) {
        // assembly/external/define_total_tiles(u32) => void
        total_tiles = total_tiles >>> 0;
        host.define_total_tiles(total_tiles);
      },
      "host.define_navmesh"(vertices, polygons, sizes) {
        // assembly/external/define_navmesh(~lib/staticarray/StaticArray<f32>, ~lib/staticarray/StaticArray<i32>, ~lib/staticarray/StaticArray<i32>) => void
        vertices = __liftStaticArray(__getF32, 2, vertices >>> 0);
        polygons = __liftStaticArray(__getI32, 2, polygons >>> 0);
        sizes = __liftStaticArray(__getI32, 2, sizes >>> 0);
        host.define_navmesh(vertices, polygons, sizes);
      },
      "host.create_player"(entity, pos_x, pos_y, radius, team) {
        // assembly/external/create_player(u32, f32, f32, f32, i32) => void
        entity = entity >>> 0;
        host.create_player(entity, pos_x, pos_y, radius, team);
      },
      "host.define_person_changes"(entity, pos_x, pos_y, angle, move_status, life, max_life, shield, max_shield, is_dead) {
        // assembly/external/define_person_changes(u32, f32, f32, f32, u32, u32, u32, f32, f32, bool) => void
        entity = entity >>> 0;
        move_status = move_status >>> 0;
        life = life >>> 0;
        max_life = max_life >>> 0;
        is_dead = is_dead != 0;
        host.define_person_changes(entity, pos_x, pos_y, angle, move_status, life, max_life, shield, max_shield, is_dead);
      },
      "host.entity_finish_melee_attack"(entity, interrupt) {
        // assembly/external/entity_finish_melee_attack(u32, bool) => void
        entity = entity >>> 0;
        interrupt = interrupt != 0;
        host.entity_finish_melee_attack(entity, interrupt);
      },
      "host.entity_finish_hand_attack"(entity, interrupt) {
        // assembly/external/entity_finish_hand_attack(u32, bool) => void
        entity = entity >>> 0;
        interrupt = interrupt != 0;
        host.entity_finish_hand_attack(entity, interrupt);
      },
      "host.entity_finish_range_attack"(entity, interrupt) {
        // assembly/external/entity_finish_range_attack(u32, bool) => void
        entity = entity >>> 0;
        interrupt = interrupt != 0;
        host.entity_finish_range_attack(entity, interrupt);
      },
      "host.entity_finish_hide"(entity, interrupt) {
        // assembly/external/entity_finish_hide(u32, bool) => void
        entity = entity >>> 0;
        interrupt = interrupt != 0;
        host.entity_finish_hide(entity, interrupt);
      },
      "host.entity_finish_shadow_attack"(entity, interrupt) {
        // assembly/external/entity_finish_shadow_attack(u32, bool) => void
        entity = entity >>> 0;
        interrupt = interrupt != 0;
        host.entity_finish_shadow_attack(entity, interrupt);
      },
      "host.entity_finish_skill"(entity, skill, interrupt) {
        // assembly/external/entity_finish_skill(u32, u32, bool) => void
        entity = entity >>> 0;
        skill = skill >>> 0;
        interrupt = interrupt != 0;
        host.entity_finish_skill(entity, skill, interrupt);
      },
      "host.entity_release_shield"(entity) {
        // assembly/external/entity_release_shield(u32) => void
        entity = entity >>> 0;
        host.entity_release_shield(entity);
      },
      "host.entity_start_shadow_attack"(entity, time, damage_distance) {
        // assembly/external/entity_start_shadow_attack(u32, f32, f32) => void
        entity = entity >>> 0;
        host.entity_start_shadow_attack(entity, time, damage_distance);
      },
      "host.entity_start_cooldawn"(entity, cooldawn_id, cooldawn_time) {
        // assembly/external/entity_start_cooldawn(u32, u32, f32) => void
        entity = entity >>> 0;
        cooldawn_id = cooldawn_id >>> 0;
        host.entity_start_cooldawn(entity, cooldawn_id, cooldawn_time);
      },
      "host.entity_start_melee_attack"(entity, time, damage_distance, damage_spread) {
        // assembly/external/entity_start_melee_attack(u32, f32, f32, f32) => void
        entity = entity >>> 0;
        host.entity_start_melee_attack(entity, time, damage_distance, damage_spread);
      },
      "host.entity_start_range_attack"(entity, time) {
        // assembly/external/entity_start_range_attack(u32, f32) => void
        entity = entity >>> 0;
        host.entity_start_range_attack(entity, time);
      },
      "host.entity_start_hand_attack"(entity, time, damage_distance) {
        // assembly/external/entity_start_hand_attack(u32, f32, f32) => void
        entity = entity >>> 0;
        host.entity_start_hand_attack(entity, time, damage_distance);
      },
      "host.entity_switch_hide"(entity, hide_active) {
        // assembly/external/entity_switch_hide(u32, bool) => void
        entity = entity >>> 0;
        hide_active = hide_active != 0;
        host.entity_switch_hide(entity, hide_active);
      },
      "host.entity_start_skill_stun_cone"(entity, cast_time, cone_spread, cone_size) {
        // assembly/external/entity_start_skill_stun_cone(u32, f32, f32, f32) => void
        entity = entity >>> 0;
        host.entity_start_skill_stun_cone(entity, cast_time, cone_spread, cone_size);
      },
      "host.click_entity"(entity, action) {
        // assembly/external/click_entity(u32, u32) => void
        entity = entity >>> 0;
        action = action >>> 0;
        host.click_entity(entity, action);
      },
      "host.click_position"(pos_x, pos_y) {
        // assembly/external/click_position(f32, f32) => void
        host.click_position(pos_x, pos_y);
      },
      "host.entity_start_shift"(entity) {
        // assembly/external/entity_start_shift(u32) => void
        entity = entity >>> 0;
        host.entity_start_shift(entity);
      },
      "host.entity_activate_shield"(entity) {
        // assembly/external/entity_activate_shield(u32) => void
        entity = entity >>> 0;
        host.entity_activate_shield(entity);
      },
      "host.entity_start_hide"(entity, activation_time) {
        // assembly/external/entity_start_hide(u32, f32) => void
        entity = entity >>> 0;
        host.entity_start_hide(entity, activation_time);
      },
      "host.entity_start_skill_round_attack"(entity, cast_time, area_size) {
        // assembly/external/entity_start_skill_round_attack(u32, f32, f32) => void
        entity = entity >>> 0;
        host.entity_start_skill_round_attack(entity, cast_time, area_size);
      },
      "host.entity_start_stun"(entity, duration) {
        // assembly/external/entity_start_stun(u32, f32) => void
        entity = entity >>> 0;
        host.entity_start_stun(entity, duration);
      },
      "host.define_total_update_entities"(count) {
        // assembly/external/define_total_update_entities(u32) => void
        count = count >>> 0;
        host.define_total_update_entities(count);
      },
      "host.define_bullet_changes"(entity, pos_x, pos_y, angle) {
        // assembly/external/define_bullet_changes(u32, f32, f32, f32) => void
        entity = entity >>> 0;
        host.define_bullet_changes(entity, pos_x, pos_y, angle);
      },
      "host.debug_entity_walk_path"(entity, points) {
        // assembly/external/debug_entity_walk_path(u32, ~lib/staticarray/StaticArray<f32>) => void
        entity = entity >>> 0;
        points = __liftStaticArray(__getF32, 2, points >>> 0);
        host.debug_entity_walk_path(entity, points);
      },
      "host.debug_close_entity"(e1, pos_x1, pos_y1, e2, pos_x2, pos_y2) {
        // assembly/external/debug_close_entity(u32, f32, f32, u32, f32, f32) => void
        e1 = e1 >>> 0;
        e2 = e2 >>> 0;
        host.debug_close_entity(e1, pos_x1, pos_y1, e2, pos_x2, pos_y2);
      },
      "host.debug_visible_quad"(start_x, start_y, end_x, end_y) {
        // assembly/external/debug_visible_quad(f32, f32, f32, f32) => void
        host.debug_visible_quad(start_x, start_y, end_x, end_y);
      },
      "host.debug_neighbourhood_quad"(start_x, start_y, end_x, end_y) {
        // assembly/external/debug_neighbourhood_quad(f32, f32, f32, f32) => void
        host.debug_neighbourhood_quad(start_x, start_y, end_x, end_y);
      },
      "host.debug_search_quad"(start_x, start_y, end_x, end_y) {
        // assembly/external/debug_search_quad(f32, f32, f32, f32) => void
        host.debug_search_quad(start_x, start_y, end_x, end_y);
      },
      "host.debug_mid_quad"(start_x, start_y, end_x, end_y) {
        // assembly/external/debug_mid_quad(f32, f32, f32, f32) => void
        host.debug_mid_quad(start_x, start_y, end_x, end_y);
      },
      "host.debug_enemies_list"(entity, search_radius, enemies) {
        // assembly/external/debug_enemies_list(u32, f32, ~lib/staticarray/StaticArray<u32>) => void
        entity = entity >>> 0;
        enemies = __liftStaticArray(pointer => __getU32(pointer) >>> 0, 2, enemies >>> 0);
        host.debug_enemies_list(entity, search_radius, enemies);
      },
      "host.tile_delete"(index) {
        // assembly/external/tile_delete(u32) => void
        index = index >>> 0;
        host.tile_delete(index);
      },
      "host.tile_create"(x, y, index, type) {
        // assembly/external/tile_create(u32, u32, u32, u32) => void
        x = x >>> 0;
        y = y >>> 0;
        index = index >>> 0;
        type = type >>> 0;
        host.tile_create(x, y, index, type);
      },
      "host.remove_entity"(entity, actor_type, remove_reason) {
        // assembly/external/remove_entity(u32, u32, u32) => void
        entity = entity >>> 0;
        actor_type = actor_type >>> 0;
        remove_reason = remove_reason >>> 0;
        host.remove_entity(entity, actor_type, remove_reason);
      },
      "host.create_monster"(entity, pos_x, pos_y, angle, radius, search_radius, search_spread, team) {
        // assembly/external/create_monster(u32, f32, f32, f32, f32, f32, f32, i32) => void
        entity = entity >>> 0;
        host.create_monster(entity, pos_x, pos_y, angle, radius, search_radius, search_spread, team);
      },
      "host.create_bullet"(entity, pos_x, pos_y, target_x, target_y, angle, bullet_type) {
        // assembly/external/create_bullet(u32, f32, f32, f32, f32, f32, u32) => void
        entity = entity >>> 0;
        bullet_type = bullet_type >>> 0;
        host.create_bullet(entity, pos_x, pos_y, target_x, target_y, angle, bullet_type);
      },
      "host.entity_finish_shift"(entity) {
        // assembly/external/entity_finish_shift(u32) => void
        entity = entity >>> 0;
        host.entity_finish_shift(entity);
      },
      "host.entity_finish_stun"(entity) {
        // assembly/external/entity_finish_stun(u32) => void
        entity = entity >>> 0;
        host.entity_finish_stun(entity);
      },
      "host.entity_damaged"(attacker_entity, target_entity, damage, damage_type) {
        // assembly/external/entity_damaged(u32, u32, u32, u32) => void
        attacker_entity = attacker_entity >>> 0;
        target_entity = target_entity >>> 0;
        damage = damage >>> 0;
        damage_type = damage_type >>> 0;
        host.entity_damaged(attacker_entity, target_entity, damage, damage_type);
      },
      "host.entity_dead"(entity) {
        // assembly/external/entity_dead(u32) => void
        entity = entity >>> 0;
        host.entity_dead(entity);
      },
    }),
  };
  const { exports } = await WebAssembly.instantiate(module, adaptedImports);
  const memory = exports.memory || imports.env.memory;
  const adaptedExports = Object.setPrototypeOf({
    create_settings() {
      // assembly/game_api/create_settings() => assembly/game/settings/Settings
      return __liftInternref(exports.create_settings() >>> 0);
    },
    settings_set_seed(settings, seed) {
      // assembly/game_api/settings_set_seed(assembly/game/settings/Settings, u32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_seed(settings, seed);
    },
    settings_set_generate(settings, level_size, room_min_size, room_max_size, rooms_count) {
      // assembly/game_api/settings_set_generate(assembly/game/settings/Settings, u32, u32, u32, u32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_generate(settings, level_size, room_min_size, room_max_size, rooms_count);
    },
    settings_set_use_debug(settings, in_use_debug) {
      // assembly/game_api/settings_set_use_debug(assembly/game/settings/Settings, bool) => void
      settings = __lowerInternref(settings) || __notnull();
      in_use_debug = in_use_debug ? 1 : 0;
      exports.settings_set_use_debug(settings, in_use_debug);
    },
    settings_set_debug_flags(settings, in_show_path, in_show_closest, in_show_visible, in_show_neighborhood, in_show_search, in_show_mid, in_show_enemy_targets) {
      // assembly/game_api/settings_set_debug_flags(assembly/game/settings/Settings, bool, bool, bool, bool, bool, bool, bool) => void
      settings = __lowerInternref(settings) || __notnull();
      in_show_path = in_show_path ? 1 : 0;
      in_show_closest = in_show_closest ? 1 : 0;
      in_show_visible = in_show_visible ? 1 : 0;
      in_show_neighborhood = in_show_neighborhood ? 1 : 0;
      in_show_search = in_show_search ? 1 : 0;
      in_show_mid = in_show_mid ? 1 : 0;
      in_show_enemy_targets = in_show_enemy_targets ? 1 : 0;
      exports.settings_set_debug_flags(settings, in_show_path, in_show_closest, in_show_visible, in_show_neighborhood, in_show_search, in_show_mid, in_show_enemy_targets);
    },
    settings_set_neighbourhood_quad_size(settings, in_size) {
      // assembly/game_api/settings_set_neighbourhood_quad_size(assembly/game/settings/Settings, f32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_neighbourhood_quad_size(settings, in_size);
    },
    settings_set_visible_quad_size(settings, in_size) {
      // assembly/game_api/settings_set_visible_quad_size(assembly/game/settings/Settings, f32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_visible_quad_size(settings, in_size);
    },
    settings_set_search_quad_size(settings, in_size) {
      // assembly/game_api/settings_set_search_quad_size(assembly/game/settings/Settings, f32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_search_quad_size(settings, in_size);
    },
    settings_set_mid_quad_size(settings, in_size) {
      // assembly/game_api/settings_set_mid_quad_size(assembly/game/settings/Settings, f32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_mid_quad_size(settings, in_size);
    },
    settings_set_rvo_time_horizon(settings, in_time) {
      // assembly/game_api/settings_set_rvo_time_horizon(assembly/game/settings/Settings, f32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_rvo_time_horizon(settings, in_time);
    },
    settings_set_use_rvo(settings, in_value) {
      // assembly/game_api/settings_set_use_rvo(assembly/game/settings/Settings, bool) => void
      settings = __lowerInternref(settings) || __notnull();
      in_value = in_value ? 1 : 0;
      exports.settings_set_use_rvo(settings, in_value);
    },
    settings_set_snap_to_navmesh(settings, in_value) {
      // assembly/game_api/settings_set_snap_to_navmesh(assembly/game/settings/Settings, bool) => void
      settings = __lowerInternref(settings) || __notnull();
      in_value = in_value ? 1 : 0;
      exports.settings_set_snap_to_navmesh(settings, in_value);
    },
    settings_set_velocity_boundary_control(settings, in_value) {
      // assembly/game_api/settings_set_velocity_boundary_control(assembly/game/settings/Settings, bool) => void
      settings = __lowerInternref(settings) || __notnull();
      in_value = in_value ? 1 : 0;
      exports.settings_set_velocity_boundary_control(settings, in_value);
    },
    settings_set_path_recalculate_time(settings, common_value, follow_value) {
      // assembly/game_api/settings_set_path_recalculate_time(assembly/game/settings/Settings, f32, f32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_path_recalculate_time(settings, common_value, follow_value);
    },
    settings_set_tiles_visible_radius(settings, in_value) {
      // assembly/game_api/settings_set_tiles_visible_radius(assembly/game/settings/Settings, i32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_tiles_visible_radius(settings, in_value);
    },
    settings_set_search_system_chunk_count(settings, in_value) {
      // assembly/game_api/settings_set_search_system_chunk_count(assembly/game/settings/Settings, u32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_search_system_chunk_count(settings, in_value);
    },
    settings_set_monster_iddle_time(settings, min_value, max_value) {
      // assembly/game_api/settings_set_monster_iddle_time(assembly/game/settings/Settings, f32, f32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_monster_iddle_time(settings, min_value, max_value);
    },
    settings_set_monsters_per_room(settings, min_value, max_value) {
      // assembly/game_api/settings_set_monsters_per_room(assembly/game/settings/Settings, u32, u32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_monsters_per_room(settings, min_value, max_value);
    },
    settings_set_select_radius_delta(settings, in_value) {
      // assembly/game_api/settings_set_select_radius_delta(assembly/game/settings/Settings, f32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_select_radius_delta(settings, in_value);
    },
    settings_set_level_tile_size(settings, in_value) {
      // assembly/game_api/settings_set_level_tile_size(assembly/game/settings/Settings, f32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_level_tile_size(settings, in_value);
    },
    settings_set_monster_random_walk_radius(settings, in_value) {
      // assembly/game_api/settings_set_monster_random_walk_radius(assembly/game/settings/Settings, f32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_monster_random_walk_radius(settings, in_value);
    },
    settings_set_bullet_max_distance(settings, in_value) {
      // assembly/game_api/settings_set_bullet_max_distance(assembly/game/settings/Settings, f32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_bullet_max_distance(settings, in_value);
    },
    settings_set_react_attack(settings, in_value) {
      // assembly/game_api/settings_set_react_attack(assembly/game/settings/Settings, bool) => void
      settings = __lowerInternref(settings) || __notnull();
      in_value = in_value ? 1 : 0;
      exports.settings_set_react_attack(settings, in_value);
    },
    settings_set_default_monster_common(settings, rotation_speed, shield_resurrect, hide_speed_multiplier, hide_activate_time, hide_cooldawn) {
      // assembly/game_api/settings_set_default_monster_common(assembly/game/settings/Settings, f32, f32, f32, f32, f32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_default_monster_common(settings, rotation_speed, shield_resurrect, hide_speed_multiplier, hide_activate_time, hide_cooldawn);
    },
    settings_set_default_monster_person(settings, radius, speed, life, search_radius, search_spread, team) {
      // assembly/game_api/settings_set_default_monster_person(assembly/game/settings/Settings, f32, f32, u32, f32, f32, i32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_default_monster_person(settings, radius, speed, life, search_radius, search_spread, team);
    },
    settings_set_player(settings, radius, speed, life, rotation_speed, shield_resurrect, default_team, shift_speed_multiplier, shift_distance, shift_cooldawn, hide_speed_multiplier, hide_cooldawn, hide_activate_time) {
      // assembly/game_api/settings_set_player(assembly/game/settings/Settings, f32, f32, u32, f32, f32, i32, f32, f32, f32, f32, f32, f32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_player(settings, radius, speed, life, rotation_speed, shield_resurrect, default_team, shift_speed_multiplier, shift_distance, shift_cooldawn, hide_speed_multiplier, hide_cooldawn, hide_activate_time);
    },
    settings_set_default_monster_weapon(settings, attack_time, attack_distance, attack_cooldawn, shield, damage, damage_distance) {
      // assembly/game_api/settings_set_default_monster_weapon(assembly/game/settings/Settings, f32, f32, f32, f32, u32, f32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_default_monster_weapon(settings, attack_time, attack_distance, attack_cooldawn, shield, damage, damage_distance);
    },
    settings_set_default_empty_weapon(settings, attack_time, attack_distance, attack_cooldawn, damage_distance, damage, shield) {
      // assembly/game_api/settings_set_default_empty_weapon(assembly/game/settings/Settings, f32, f32, f32, f32, u32, f32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_default_empty_weapon(settings, attack_time, attack_distance, attack_cooldawn, damage_distance, damage, shield);
    },
    settings_set_default_shadow_weapon(settings, attack_time, attack_distance, attack_cooldawn, damage_distance) {
      // assembly/game_api/settings_set_default_shadow_weapon(assembly/game/settings/Settings, f32, f32, f32, f32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_default_shadow_weapon(settings, attack_time, attack_distance, attack_cooldawn, damage_distance);
    },
    settings_set_skill_round_attack(settings, cast_time, cooldawn, damage, area_radius) {
      // assembly/game_api/settings_set_skill_round_attack(assembly/game/settings/Settings, f32, f32, u32, f32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_skill_round_attack(settings, cast_time, cooldawn, damage, area_radius);
    },
    settings_set_skill_stun_cone(settings, cast_time, cooldawn, distance, damage, cone_spread, cone_size, stun_time) {
      // assembly/game_api/settings_set_skill_stun_cone(assembly/game/settings/Settings, f32, f32, f32, u32, f32, f32, f32) => void
      settings = __lowerInternref(settings) || __notnull();
      exports.settings_set_skill_stun_cone(settings, cast_time, cooldawn, distance, damage, cone_spread, cone_size, stun_time);
    },
    dev_game_resurrect_player(game) {
      // assembly/game_api/dev_game_resurrect_player(assembly/game/Game) => void
      game = __lowerInternref(game) || __notnull();
      exports.dev_game_resurrect_player(game);
    },
    dev_game_spawn_monster(game, radius, position_x, position_y, move_speed, life, virtual_weapon, search_radius, search_spread, team, friend_for_player) {
      // assembly/game_api/dev_game_spawn_monster(assembly/game/Game, f32, f32, f32, f32, u32, assembly/game/virtuals/VirtualWeapon, f32, f32, i32, bool) => void
      game = __retain(__lowerInternref(game) || __notnull());
      virtual_weapon = __lowerInternref(virtual_weapon) || __notnull();
      friend_for_player = friend_for_player ? 1 : 0;
      try {
        exports.dev_game_spawn_monster(game, radius, position_x, position_y, move_speed, life, virtual_weapon, search_radius, search_spread, team, friend_for_player);
      } finally {
        __release(game);
      }
    },
    dev_game_move_entity(game, entity, pos_x, pos_y) {
      // assembly/game_api/dev_game_move_entity(assembly/game/Game, u32, f32, f32) => void
      game = __lowerInternref(game) || __notnull();
      exports.dev_game_move_entity(game, entity, pos_x, pos_y);
    },
    dev_add_sword_to_player(game, attack_distance, attack_time, attack_cooldawn, damage, shield, damage_spread, damage_distance) {
      // assembly/game_api/dev_add_sword_to_player(assembly/game/Game, f32, f32, f32, u32, f32, f32, f32) => void
      game = __lowerInternref(game) || __notnull();
      exports.dev_add_sword_to_player(game, attack_distance, attack_time, attack_cooldawn, damage, shield, damage_spread, damage_distance);
    },
    dev_add_bow_to_player(game, attack_distance, attack_time, attack_cooldawn, damage, shield, speed) {
      // assembly/game_api/dev_add_bow_to_player(assembly/game/Game, f32, f32, f32, u32, f32, f32) => void
      game = __lowerInternref(game) || __notnull();
      exports.dev_add_bow_to_player(game, attack_distance, attack_time, attack_cooldawn, damage, shield, speed);
    },
    dev_player_equip_sword(game) {
      // assembly/game_api/dev_player_equip_sword(assembly/game/Game) => void
      game = __lowerInternref(game) || __notnull();
      exports.dev_player_equip_sword(game);
    },
    dev_player_equip_bow(game) {
      // assembly/game_api/dev_player_equip_bow(assembly/game/Game) => void
      game = __lowerInternref(game) || __notnull();
      exports.dev_player_equip_bow(game);
    },
    dev_player_equip_free_hands(game) {
      // assembly/game_api/dev_player_equip_free_hands(assembly/game/Game) => void
      game = __lowerInternref(game) || __notnull();
      exports.dev_player_equip_free_hands(game);
    },
    dev_create_virtual_sword(game, attack_distance, attack_time, attack_cooldawn, shield, damage, damage_distance, damage_spread) {
      // assembly/game_api/dev_create_virtual_sword(assembly/game/Game, f32, f32, f32, f32, u32, f32, f32) => assembly/game/virtuals/VirtualWeapon
      game = __lowerInternref(game) || __notnull();
      return __liftInternref(exports.dev_create_virtual_sword(game, attack_distance, attack_time, attack_cooldawn, shield, damage, damage_distance, damage_spread) >>> 0);
    },
    dev_create_virtual_bow(game, attack_distance, attack_time, attack_cooldawn, shield, damage, bullet_speed) {
      // assembly/game_api/dev_create_virtual_bow(assembly/game/Game, f32, f32, f32, f32, u32, f32) => assembly/game/virtuals/VirtualWeapon
      game = __lowerInternref(game) || __notnull();
      return __liftInternref(exports.dev_create_virtual_bow(game, attack_distance, attack_time, attack_cooldawn, shield, damage, bullet_speed) >>> 0);
    },
    dev_create_virtual_empty_weapon(game, attack_distance, attack_time, attack_cooldawn, shield, damage, damage_distance) {
      // assembly/game_api/dev_create_virtual_empty_weapon(assembly/game/Game, f32, f32, f32, f32, u32, f32) => assembly/game/virtuals/VirtualWeapon
      game = __lowerInternref(game) || __notnull();
      return __liftInternref(exports.dev_create_virtual_empty_weapon(game, attack_distance, attack_time, attack_cooldawn, shield, damage, damage_distance) >>> 0);
    },
    create_game(settings) {
      // assembly/game_api/create_game(assembly/game/settings/Settings) => assembly/game/Game
      settings = __lowerInternref(settings) || __notnull();
      return __liftInternref(exports.create_game(settings) >>> 0);
    },
    game_update(game, dt) {
      // assembly/game_api/game_update(assembly/game/Game, f32) => void
      game = __lowerInternref(game) || __notnull();
      exports.game_update(game, dt);
    },
    game_client_point(game, in_x, in_y) {
      // assembly/game_api/game_client_point(assembly/game/Game, f32, f32) => void
      game = __lowerInternref(game) || __notnull();
      exports.game_client_point(game, in_x, in_y);
    },
    game_client_shift(game, cursor_x, cursor_y) {
      // assembly/game_api/game_client_shift(assembly/game/Game, f32, f32) => void
      game = __lowerInternref(game) || __notnull();
      exports.game_client_shift(game, cursor_x, cursor_y);
    },
    game_client_shield(game) {
      // assembly/game_api/game_client_shield(assembly/game/Game) => void
      game = __lowerInternref(game) || __notnull();
      exports.game_client_shield(game);
    },
    game_client_release_shield(game) {
      // assembly/game_api/game_client_release_shield(assembly/game/Game) => void
      game = __lowerInternref(game) || __notnull();
      exports.game_client_release_shield(game);
    },
    game_client_toggle_hide(game) {
      // assembly/game_api/game_client_toggle_hide(assembly/game/Game) => void
      game = __lowerInternref(game) || __notnull();
      exports.game_client_toggle_hide(game);
    },
    game_skill_nontarget(game, skill) {
      // assembly/game_api/game_skill_nontarget(assembly/game/Game, i32) => bool
      game = __lowerInternref(game) || __notnull();
      return exports.game_skill_nontarget(game, skill) != 0;
    },
    game_skill_target(game, position_x, position_y, skill) {
      // assembly/game_api/game_skill_target(assembly/game/Game, f32, f32, i32) => bool
      game = __lowerInternref(game) || __notnull();
      return exports.game_skill_target(game, position_x, position_y, skill) != 0;
    },
    game_add_monsters(game) {
      // assembly/game_api/game_add_monsters(assembly/game/Game) => void
      game = __lowerInternref(game) || __notnull();
      exports.game_add_monsters(game);
    },
    game_make_aggressive(game) {
      // assembly/game_api/game_make_aggressive(assembly/game/Game) => void
      game = __lowerInternref(game) || __notnull();
      exports.game_make_aggressive(game);
    },
    game_damage_all_entities(game, damage) {
      // assembly/game_api/game_damage_all_entities(assembly/game/Game, u32) => void
      game = __lowerInternref(game) || __notnull();
      exports.game_damage_all_entities(game, damage);
    },
    game_stun_all_entities(game, duration) {
      // assembly/game_api/game_stun_all_entities(assembly/game/Game, f32) => void
      game = __lowerInternref(game) || __notnull();
      exports.game_stun_all_entities(game, duration);
    },
  }, exports);
  function __liftString(pointer) {
    if (!pointer) return null;
    const
      end = pointer + new Uint32Array(memory.buffer)[pointer - 4 >>> 2] >>> 1,
      memoryU16 = new Uint16Array(memory.buffer);
    let
      start = pointer >>> 1,
      string = "";
    while (end - start > 1024) string += String.fromCharCode(...memoryU16.subarray(start, start += 1024));
    return string + String.fromCharCode(...memoryU16.subarray(start, end));
  }
  function __liftStaticArray(liftElement, align, pointer) {
    if (!pointer) return null;
    const
      length = __getU32(pointer - 4) >>> align,
      values = new Array(length);
    for (let i = 0; i < length; ++i) values[i] = liftElement(pointer + (i << align >>> 0));
    return values;
  }
  class Internref extends Number {}
  const registry = new FinalizationRegistry(__release);
  function __liftInternref(pointer) {
    if (!pointer) return null;
    const sentinel = new Internref(__retain(pointer));
    registry.register(sentinel, pointer);
    return sentinel;
  }
  function __lowerInternref(value) {
    if (value == null) return 0;
    if (value instanceof Internref) return value.valueOf();
    throw TypeError("internref expected");
  }
  const refcounts = new Map();
  function __retain(pointer) {
    if (pointer) {
      const refcount = refcounts.get(pointer);
      if (refcount) refcounts.set(pointer, refcount + 1);
      else refcounts.set(exports.__pin(pointer), 1);
    }
    return pointer;
  }
  function __release(pointer) {
    if (pointer) {
      const refcount = refcounts.get(pointer);
      if (refcount === 1) exports.__unpin(pointer), refcounts.delete(pointer);
      else if (refcount) refcounts.set(pointer, refcount - 1);
      else throw Error(`invalid refcount '${refcount}' for reference '${pointer}'`);
    }
  }
  function __notnull() {
    throw TypeError("value must not be null");
  }
  let __dataview = new DataView(memory.buffer);
  function __getI32(pointer) {
    try {
      return __dataview.getInt32(pointer, true);
    } catch {
      __dataview = new DataView(memory.buffer);
      return __dataview.getInt32(pointer, true);
    }
  }
  function __getU32(pointer) {
    try {
      return __dataview.getUint32(pointer, true);
    } catch {
      __dataview = new DataView(memory.buffer);
      return __dataview.getUint32(pointer, true);
    }
  }
  function __getF32(pointer) {
    try {
      return __dataview.getFloat32(pointer, true);
    } catch {
      __dataview = new DataView(memory.buffer);
      return __dataview.getFloat32(pointer, true);
    }
  }
  return adaptedExports;
}
